export default {
  log(...data: any[]) {
    if (process.env.VUE_APP_LOGGER_ENABLED === 'true') {
      console.log(data.join(''));
    }
  },
};
